import { useMemo } from 'react'
import { useMappingCompanies } from './useMappingCompanies'
import { useGroupSourceMaps } from './useGroupSourceMaps'
import { buildMappingMatrix } from '../utils/buildMappingMatrix'

export const useMappingStats = () => {
  const { companies, groupCompany, isLoading: isCompaniesLoading, isError: isCompaniesError } = useMappingCompanies()
  const companyIds = useMemo(() => companies.map(company => company.id), [companies])
  const {
    data: sourceMaps = [],
    isLoading: isSourceMapsLoading,
    isError: isSourceMapsError
  } = useGroupSourceMaps(companyIds)
  const { rows, stats } = useMemo(() => buildMappingMatrix(companies, sourceMaps), [companies, sourceMaps])

  return {
    companies,
    groupCompany,
    sourceMaps,
    rows,
    stats,
    isCompaniesLoading,
    isSourceMapsLoading,
    isError: isCompaniesError || isSourceMapsError
  }
}
